module.exports = __webpack_public_path__ + "img/py7.png";